import { z } from "zod";

export enum OtpPurpose {
	ChangePassword = "Change Password",
	ResetPassword = "Reset Password",
	Login = "Login",
}

export const generateOtpInput = z.object({
	purpose: z.nativeEnum(OtpPurpose),
});

export const generatedOtp = z.object({
	otp: z.string(),
});

export type GenerateOtpDto = z.infer<typeof generatedOtp>;
